import { useRouter } from "next/router";

import { Login } from "@mosanic/auth";

const SignInPage = ({}) => {
  const query = useRouter()?.query;

  return (
    <Login verifyCode={query?.verify} resetCode={query?.resetCode || query?.reset} />
  );
}

export default SignInPage;
